namespace Matrix.Data {
    export interface SecurityValueRow {
        SecurityId?: number;
        SourceCode?: string;
        InstanceCode?: string;
        AsAtDate?: string;
        PriceLocal?: number;
        Yield?: number;
        ModifiedDuration?: number;
        Delta?: number;
        Gamma?: number;
        Theta?: number;
        Vega?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        RowId?: number;
        Version?: number;
    }

    export namespace SecurityValueRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'SourceCode';
        export const localTextPrefix = 'Data.SecurityValue';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:SecurityValue';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            SourceCode = "SourceCode",
            InstanceCode = "InstanceCode",
            AsAtDate = "AsAtDate",
            PriceLocal = "PriceLocal",
            Yield = "Yield",
            ModifiedDuration = "ModifiedDuration",
            Delta = "Delta",
            Gamma = "Gamma",
            Theta = "Theta",
            Vega = "Vega",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            RowId = "RowId",
            Version = "Version"
        }
    }
}
